"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorItem = void 0;
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_1 = __importDefault(require("react"));
var colorConfig_1 = require("./colorConfig");
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        position: 'relative',
        cursor: 'pointer',
        width: colorConfig_1.ITEM_WIDTH,
        height: colorConfig_1.ITEM_WIDTH,
    },
    color: {
        width: '100%',
        height: '100%',
    },
    picked: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        margin: 'auto',
    }
}); });
exports.ColorItem = function (_a) {
    var color = _a.color, isPicked = _a.isPicked, onClick = _a.onClick;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { className: classes.root, onClick: onClick },
        react_1.default.createElement(core_1.Box, { className: classes.color, style: { backgroundColor: color } }),
        react_1.default.createElement(core_1.Box, { className: classes.picked, display: 'flex', alignItems: 'center', justifyContent: 'center' }, !!isPicked && react_1.default.createElement(icons_1.CheckCircle, null))));
};
